import { Input } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface IHostProps {
  isEditable: boolean;
  host?: string;
  parent?: string;
  onChange: (path: string[], val: string) => void;
}
export const Host: FC<IHostProps> = ({ isEditable, host, onChange, parent }) => {
  const label = !host && parent ? `${parent} (inherited)` : 'Host';
  const isError = !host && !parent;

  return (
    <Input
      label={label}
      type="text"
      name="host"
      id="host"
      value={host || ''}
      onChange={e => onChange(['host'], e.target.value)}
      placeholder="api.example.com"
      disabled={!isEditable}
      sx={{ marginY: 2 }}
      autoComplete="off"
      error={isError}
    />
  );
};
